import { useRef } from "react";
import { useSuspenseQuery } from "@tanstack/react-query";
import { Typography } from "antd";
import { Outlet, useLocation } from "react-router-dom";
import "./project-general-view.scss";
import { ProjectTabs } from "@/features/project-tabs";
import { routes, useAppRoutes } from "@/shared/lib/react-router";
import { projectQueries } from "@entities/project";
import { useCoordinator } from "@shared/lib/hooks";
import { Breadcrumbs } from "@shared/ui";
import { isUnifiedRoute } from "@shared/utils";

const { Title } = Typography;

const generateBreadcrumbs = (projectId: string, projectShortName: string) => {
  return [
    { path: routes.projects(), label: "Проекты" },
    {
      path: routes.project.root({ projectId }),
      label: projectShortName,
    },
  ];
};

export const ProjectGeneralView = () => {
  const { projectId } = useCoordinator();
  const location = useLocation();
  const appRoutes = useAppRoutes();
  const isUnified = isUnifiedRoute(location.pathname);
  const ref = useRef<HTMLDivElement | null>(null);

  const normalizePath = (path: string) => path.replace(/\/+$/, "");

  const isRecordsRegisterPage =
    normalizePath(location.pathname) ===
    normalizePath(appRoutes.general.recordsRegister(projectId));

  const { data: project } = useSuspenseQuery(
    projectQueries.getProject({ projectId }),
  );

  return (
    <div ref={ref} className="general-view-container">
      {!isRecordsRegisterPage && (
        <>
          <Breadcrumbs
            routes={generateBreadcrumbs(project.projectId, project.shortName)}
            disableFirst={isUnified ? 2 : 0}
          />
          <Title level={3} style={{ marginBottom: "32px" }}>
            {project.shortName}
          </Title>
          <ProjectTabs />
        </>
      )}
      <Outlet
        context={{
          wrapperRef: ref,
        }}
      />
    </div>
  );
};
